import AddressEntry from './AddressEntry';

export default AddressEntry;
